import type { ICotizacionPostventa, IConceptoCostoPostventa, IRepuestoPostventa, UnidadTiempoPostventa } from '../../../modelos/CotizadorPostventa/entidades/ICotizacionPostventa';
import type { IConfiguracionPostventa } from '../../../modelos/CotizadorPostventa/entidades/IConfiguracionPostventa';
import type { IResultadoCotizacionPostventa } from '../../../modelos/CotizadorPostventa/entidades/IResultadoCotizacionPostventa';
import { generarIdTemporal } from '../../../globales/componentes/tabla/useEdicionFilas';

/** Secciones de costos con la misma forma (ítem, costo, detalle). */
export type SeccionConceptos = 'Transportes' | 'Viaticos' | 'KnowHow' | 'OtrosCostos';

export const UNIDADES_TIEMPO: UnidadTiempoPostventa[] = ['Días', 'Semanas', 'Meses'];

const concepto = (Item: string): IConceptoCostoPostventa => ({ Id: generarIdTemporal(), Item, Costo: 0, Detalle: '' });

/** Cotización nueva: toma de la configuración el factor precio y la tarifa hora hombre. */
export const cotizacionPostventaInicial = (configuracion: IConfiguracionPostventa): ICotizacionPostventa => ({
    Proyecto: '',
    Cliente: '',
    Descripcion: '',
    NumeroUnidades: 1,
    Repuestos: [],
    PesoGuacalKg: 0,
    DimensionesGuacal: '',
    HorasHombre: 0,
    TarifaHoraHombre: configuracion.TarifaHoraHombre,
    DetalleManoObra: '',
    Transportes: [],
    Viaticos: [],
    KnowHow: [],
    // Los dos conceptos que trae el Excel por defecto.
    OtrosCostos: [concepto('Certificación'), concepto('Insumos')],
    TiempoFabricacion: 0,
    TiempoInstalacion: 0,
    UnidadTiempo: 'Días',
    FactorPrecio: configuracion.FactorPrecio,
    CostoImportacion: 0
});

export const nuevoRepuesto = (): IRepuestoPostventa => ({
    Id: generarIdTemporal(),
    Item: '',
    CostoUnitario: '' as unknown as number,
    Cantidad: 1,
    // 1 = el costo ya está en COP.
    Trm: 1,
    IncotermId: '',
    Detalle: ''
});

export const nuevoConcepto = (): IConceptoCostoPostventa => ({ Id: generarIdTemporal(), Item: '', Costo: '' as unknown as number, Detalle: '' });

/**
 * Resultado en cero con la forma que entrega el back.
 * Solo para ver el diseño del resumen: los valores los calcula el back.
 */
export const resultadoSinCalcular = (cotizacion: ICotizacionPostventa): IResultadoCotizacionPostventa => ({
    SubtotalesRepuestos: cotizacion.Repuestos.map(r => ({ RepuestoId: r.Id, Subtotal: 0 })),
    Costos: { Repuestos: 0, ManoObra: 0, Transporte: 0, Viaticos: 0, KnowHow: 0, Otros: 0 },
    TotalCostoUnitario: 0,
    PrecioVentaUnitario: 0,
    PrecioVentaTotal: 0,
    MargenBruto: 0,
    TiempoTotal: 0
});

export const formatoMoneda = (valor?: number) => `$ ${(valor ?? 0).toLocaleString('es-CO', { maximumFractionDigits: 0 })}`;

/** Campos de la cotización que se editan con inputs (fuera de las tablas). */
export type CampoCotizacionPostventa = Exclude<keyof ICotizacionPostventa, 'Repuestos' | SeccionConceptos | 'Resultado' | 'Estado'>;
